import React from 'react';
import { pageContainerStyle, sectionedPanelStyle } from '../CampaignStyles';
import { sectionTitleStyle } from '../Properties/ShowStyles';
import AirtimeBurstPropertiesPanel from './AirtimeBurstsPropertiesPanel';
import AirtimeBurstsGrid from './AirtimeBurstsGrid';

const AirtimeBursts = ({ campaign, campaignBursts, readOnly, deleteBurst }) => {
    return (
        <div style={pageContainerStyle}>
            <div
                style={{
                    ...sectionedPanelStyle,
                    padding: '11.5px 24px 12px 24px'
                }}
            >
                <span style={{ ...sectionTitleStyle, fontSize: 17 }}>{window.translate('Airtime Bursts')}</span>
                <AirtimeBurstPropertiesPanel
                    campaign={campaign}
                    campaignBursts={campaignBursts}
                    readOnly={readOnly}
                />
                <AirtimeBurstsGrid
                    campaign={campaign}
                    campaignBursts={campaignBursts}
                    deleteBurst={deleteBurst}
                    readOnly={readOnly}
                />
            </div>
        </div>
    );
};

export default AirtimeBursts;
